<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/rjs74D/tc-custom/9781453289228.jpg?1733124142413" alt="This image is the cover for the book Terrible Tide"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Terrible Tide
      </h1>
      <p class="bookDescription body article font2">
        <b>A supposedly haunted house contains even more frightening secrets among the living in this cozy mystery from the international bestselling author.</b><br/>  Holly Howe is just beginning to succeed in in the cutthroat world of New York modeling when a car accident ruins her good looks forever and she is forced to retreat to the backwoods of Canada, to recuperate in her brother’s ramshackle country house. But Howe Hill is a wreck—dusty, ugly, and utterly lacking in modern facilities—and her brother is no more hospitable. So when Holly hears of a job in town taking care of Mrs. Partlett, an elderly, widowed invalid, she leaps at the opportunity. If nothing else, the Partlett mansion must have indoor plumbing. But Holly soon finds that while Cliff House is eerie by day, it’s terrifying by night. The other housekeeper is convinced it’s haunted by the ghost of Mr. Partlett, but Holly fears no poltergeist. It’s the old widow in the upstairs room that frightens her—and the secrets that lurk behind her dull, silver eyes.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Charlotte MacLeod
      </h2>
      
      <p class="authorDescription body article">Charlotte MacLeod (1922&ndash;2005) was an international&#160;bestselling author of cozy mysteries. Born in Canada, she moved to Boston as a child&#160;and lived in New England most of her life. After graduating from college, she made a career in advertising, writing copy for the Stop &amp; Shop Supermarket Company before moving on to Boston firm N. H. Miller &amp; Co., where she rose to the rank of vice president. In her spare time, MacLeod wrote short stories, and in 1964 published her first novel, a children&rsquo;s book called <I>Mystery of the White Knight.</I><I>&#160;</I>In <I>Rest You Merry</I> (1978), MacLeod introduced Professor Peter Shandy, a horticulturist and amateur sleuth whose adventures she would chronicle for two decades. <I>The Family Vault </I>(1979) marked the first appearance of her other best-known characters: the husband and wife sleuthing team Sarah Kelling and Max Bittersohn, whom she followed until her last novel, <I>The Balloon Man</I>, in 1998.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?23878346